import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { ReportQueryKeys } from "./keys";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ICustomerReport } from "../../models/Reports/CustomerReportLink";


export default function useReportCustomerLinks(reportId: string) {
  const { get } = useApiHelper();

  const reportCustomerLinks = useQuery({
    queryKey: ReportQueryKeys.reportCustomerLinks(reportId),
    queryFn: () =>
      get<IDefaultResponse<ICustomerReport[]>>(`/report/${reportId}/customer-links`).then(
        (res) => res.data,
      ),
    enabled: !!reportId,
  });

  return {
    reportCustomerLinks,
  };
}
